import { SLIDE_NODE } from "./Constants";
// function to fetchThe desiredSlide from list of slides at stateTree.notebook.designSection
export function fetchDesignSlide(allSlides, slideType) {
  return allSlides.find((slide) => slide.type === slideType);
}

// function to check if NodeOpearations Complete for DesignSlideTwo:
export function checkIfNodeComplete(nodeItem) {
  switch (nodeItem.nodeType) {
    case SLIDE_NODE.START_NODE:
    case SLIDE_NODE.BOX_DRAG_DROP:
    case SLIDE_NODE.JOINT_DRAG_DROP:
      return isNodeComplete(nodeItem);
    case SLIDE_NODE.JOINT_PATH_SELECT:
      return isPathSelectComplete(nodeItem);
    default:
      return false;
  }
}

function isNodeComplete(nodeItem) {
  return nodeItem.nodeComponents.every(
    (component) => component.id === component.droppedId
  );
}

function isPathSelectComplete(nodeItem) {
  const selectedNode = nodeItem.nodeOptions.find((option) => option.selected);
  if (selectedNode && selectedNode.id === nodeItem.nodeComponent) {
    return true;
  } else {
    return false;
  }
}

// to fetch all Id keys in ArrayOfObjects.
export function fetchComponentIds(componentList) {
  return componentList.map((listItem) => listItem.id);
}

// fetch the node with current: true
export function fetchCurrentNode(slideTree) {
  const findFromGroups = (currentNode, group) => {
    if (currentNode === null) {
      const current = group.groupNodes.find((node) => node.current === true);
      if (current) {
        currentNode = current;
      }
    }
    return currentNode;
  };
  return slideTree.reduce(findFromGroups, null);
}

// function to check if a DNDQ component is correct;
export function checkSlidersCorrect(sliders) {
  return sliders.reduce((boolVal, slider) => {
    if (
      boolVal === true &&
      slider.disable === false &&
      JSON.stringify(slider.answer) !== JSON.stringify(slider.current)
    ) {
      boolVal = false;
    }
    return boolVal;
  }, true);
}

// function to check if a GROUPED_DNDQ component is correct;
export function checkAllSliderGroupsCorrect(sliderGroups) {
  return sliderGroups.reduce((boolValue, group) => {
    const groupIsCorrect = checkSlidersCorrect(group.sliders);
    if (groupIsCorrect === false) {
      boolValue = false;
    }
    return boolValue;
  }, true);
}

// function to reset updated keyInList [parameter can be sliderGroups or sliders]
export function resetUpdatedKeyInDNDQ(sliderGroups) {
  return sliderGroups.map((group) => ({ ...group, updated: false }));
}

// function to check if checkbox/radio selection valid for CSCQ/MSCQ components
export function checkIfSelectionValid(component) {
  return (
    (component.totalAttempts === -10 || component.totalAttempts > 0) &&
    component.complete === false
  );
}

//scrollTo top of the section
export function scrollToSectionTop(selector) {
  document.querySelector(selector).scrollTo(0, 0);
}

/**
 * Function that loops over GlossaryItems list
 * and classify them based on first letter
 */
const GLOSSARY_ITEM_TYPE = {
  VALUE: "value",
  TITLE: "title",
};
export function makeGroupedGlossaryList(glossaryList) {
  const { list } = glossaryList.reduce(
    ({ category, list }, listItem, index) => {
      const firstLetter = listItem.title.substring(0, 1).toUpperCase();
      if (firstLetter === category) {
        list.push({ ...listItem, type: GLOSSARY_ITEM_TYPE.VALUE });
      } else {
        category = firstLetter;
        list.push({
          type: GLOSSARY_ITEM_TYPE.TITLE,
          title: firstLetter,
          id: `${index}_${firstLetter}`,
        });
        list.push({
          ...listItem,
          type: GLOSSARY_ITEM_TYPE.VALUE,
        });
      }
      return { category, list };
    },
    { category: null, list: [] }
  );
  return list;
}

/**
 * Function to loop over GlossaryItems list
 * and fetch all titles and contentids
 * for setting highlight tag
 */
export function makeHighlightWordsList(glossaryList) {
  return glossaryList.map((listItem) => ({
    id: listItem.id,
    title: listItem.title,
  }));
}

/**
 * Throttle function for scroll and resize events
 */
let throttleTimer = null;
export function throttle(callback, interval = 15) {
  if (throttleTimer) {
    clearTimeout(throttleTimer);
    throttleTimer = null;
  }
  throttleTimer = setTimeout(callback, interval);
}

/**
 * Function to check if a QuestionComponent has more Attempts
 */
export function hasAttempts(totalAttempts) {
  if (totalAttempts === -10) return true;
  else return totalAttempts > 0;
}

/**
 * Funciton to check if a Microcentrifuge is balanced
 */
export function isMicrocentrifugeBalanced(slots) {
  const UNBALANCED_TUBE_COUNTS = [0, 1, 5, 7, 11];
  const totalDroppedSlots = slots.reduce((count, slot) => {
    if (slot.solutionId !== null && slot.solutionId >= 0) count++;
    return count;
  }, 0);
  if (UNBALANCED_TUBE_COUNTS.includes(totalDroppedSlots)) return false;
  else {
    const totalSlots = slots.length;
    /* Get list of gap between each slots. */
    const gapList = [];
    let gapSize = 0;
    for (let i = 0; i < totalSlots; i++) {
      if (slots[i].solutionId === null) {
        gapSize += 1;
      } else if (gapSize > 0) {
        gapList.push(gapSize);
        gapSize = 0;
      } else {
        continue;
      }
    }
    /* If last slot is unfilled it will leave a gapsize which has to be added to gapList */
    if (gapSize) {
      /* If first slot was empty means left over gap needs to be added with first gapSize */
      if (slots[0].solutionId === null && gapList.length) gapList[0] += gapSize;
      else gapList.push(gapSize);
    }
    /**
     * - more than one gap means all gapSizes needs to be same to be balanced
     * - single gap means unbalanced
     * - no gaps means all 12 slots filled means balanced
     */
    if (gapList.length > 1) return gapList.every((size) => gapList[0] === size);
    else if (gapList.length === 1) return false;
    else return true;
  }
}

export function resetScroll(selector) {
  const element = document.querySelector("." + selector);
  if (element) element.scrollTop = 0;
}
